import { gql } from 'graphql-tag';

export const CREATE_QUOTE_PROPOSAL = gql`
  mutation CreateQuoteProposal($input: CreateQuoteProposalInput!) {
    result: createQuoteProposal(input: $input) {
      error
      success
      entity {
        id
      }
    }
  }
`;
